<script lang="ts">
  import { writable } from 'svelte/store';

  // *** This file is part of DbGate Premium ***

  import { getFormContext } from '../forms/FormProviderCore.svelte';
  import AdminConnectionsGridCore from './AdminConnectionsGridCore.svelte';

  export let filters = writable({});

  const { values, setFieldValue } = getFormContext();

  $: allConnections = $values.allConnections;
  $: usedConnections = $values.usedConnections;
</script>

<div class="flex1 scroll mt-3">
  <AdminConnectionsGridCore
    {allConnections}
    {filters}
    checkedKeys={usedConnections}
    onSetCheckedKeys={keys => setFieldValue('usedConnections', keys)}
    on:clickrow={e => {
      const id = e.detail.id;
      if (usedConnections.includes(id))
        setFieldValue(
          'usedConnections',
          usedConnections.filter(x => x != id)
        );
      else setFieldValue('usedConnections', [...usedConnections, id]);
      // selectedObjectId = e.detail.id;
    }}
  ></AdminConnectionsGridCore>
</div>
